<template>
  <div class="card-company-plan">
    <a class="card-company-plan-link" @click="routerPage(admin)">
      <div class="card-company-plan__header">
        <p>
          {{ admin.name }}
        </p>
        <div
          class="card-company-plan__status"
          :class="{
            'card-company-plan__status--active': admin.is_active,
          }"
        >
          <template v-if="admin.is_active"> Ativado </template>
          <template v-else> Desativado </template>
        </div>
      </div>
      <div class="card-company-plan__text">
        <p>
          Empresa: <b>{{ admin.company_name }}</b>
        </p>
        <p>
          Departamento: <b>{{ admin.department_name }}</b>
        </p>
      </div>
    </a>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    admin: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(["getSlugify"]),
    async routerPage(admin) {
      this.$router.push({
        name: "EditAdminCompany",
        params: {
          id: admin.id_company,
          idCompanyAdmin: admin.id,
          slug: await this.getSlugify(admin.company_name),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-company-plan {
  position: relative;
  height: 200px;
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  &-link {
    height: 100%;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &__text {
    padding: 15px;
    height: 100%;
    text-align: left;
    p {
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--black);
      margin-bottom: 0;
    }
  }
  &__header {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--gray-light);
    p {
      font-size: 20px;
      font-family: "Font Bold";
      color: var(--black);
      max-width: 210px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 0;
    }
  }
  &-btn {
    padding: 15px;
    .btn-yellow {
      margin-bottom: 0;
    }
  }
  &__status {
    width: max-content;
    background: var(--yellow-dark);
    padding: 5px 15px;
    border-radius: 30px;
    font-family: "Font Semibold";
    color: var(--white);
    font-size: 12px;
    &--active {
      background: var(--green-2);
    }
  }
}
</style>
